<template>
  <div>
    <right-banner-template :title="title">
      <div v-for="(lt, i) in $store.getters['about/finalLocation']" :key="i">
        <p class="title">{{ lt.header }}</p>
        <p class="location">{{ lt.location }}</p>
      </div>
      <LocationMap></LocationMap>
    </right-banner-template>
  </div>
</template>

<script>
import LocationMap from './LocationMap.vue'

export default {
  props: ['title'],
  components: {
    LocationMap
  }
}
</script>

<style scoped>
  .title {
    color: #e3b032;
    font-weight: bold;
    font-size: 18px;
  }

  .location {
    margin-bottom: 20px;
  }

</style>
